import React, { useState, useEffect } from 'react'
import { Link, useLocation } from "react-router-dom";

import './navbar.css'

function Navbar({isHome}) {
    const current = useLocation()

    const [matches, setMatches] = useState(
        window.matchMedia("(min-width: 768px)").matches
    )
    
    useEffect(() => {
        window
        .matchMedia("(min-width: 768px)")
        .addEventListener('change', e => setMatches( e.matches ));
    }, []);

    const [stickyClass, setStickyClass] = useState('');

    useEffect(() => {
        window.addEventListener('scroll', stickNavbar);
        return () => window.removeEventListener('scroll', stickNavbar);
    }, []);

    const stickNavbar = () => {
        if (window !== undefined) {
        let windowHeight = window.scrollY;
        windowHeight > (isHome ? ((matches ? 1 : 0.85)*window.innerHeight) : 0) ? setStickyClass('sticky-nav') : setStickyClass('');
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        stickNavbar();
    }, [current]);

    const [menuOpen, setMenuOpen] = useState(true)

    function toggleMenu() {
        setMenuOpen(!menuOpen)
    }

    const desktopLayout = <>
        <nav className={`vfs__navbar flexRow ${stickyClass}`}>
            <div className='vfs__navBrand'><Link to='/'></Link></div>
            <ul className='vfs__navMenu flexRow'>
                <li className='vfs__navItem vfs__navBold'><h5><Link to={null}>CONTRIBUTE</Link></h5></li>
            </ul>
        </nav> 
    </>

    const mobileLayout = <>
        <nav>
            <ul className={`vfs__navbar vfs__navMenu flexRow ${stickyClass}`}>
                <li className='vfs__navItem vfs__navBrand'><Link to='/'></Link></li>
                <li className='vfs__navHamburger' onClick={() => toggleMenu()}></li>
            </ul>
            <ul className={`vfs__navbar vfs__navMobile ${menuOpen ? 'hidden' : ''} ${stickyClass}`}>
                
            </ul>
        </nav> 
    </>

    return (  
        <>{matches ? desktopLayout : mobileLayout}</>  
    )
} export default Navbar; 